import { encodeObject } from '../classes/Encodeable.js';
/**
 * Stores an encoding version alongside data as { version, data }, so persisted
 * data can be decoded using its original format rather than the current version.
 */
export class VersionBox {
    data;
    constructor(data) {
        this.data = data;
    }
    encode(context) {
        return {
            data: encodeObject(this.data, context),
            version: context.version,
        };
    }
}
/** Decodes a versioned envelope and returns a VersionBox; access the value through .data. */
export class VersionBoxDecoder {
    decoder;
    constructor(decoder) {
        this.decoder = decoder;
    }
    /**
     * Replaces the supplied context.version with the envelope's version before
     * decoding its payload. ObjectData children share that context, so use a
     * fresh context when this must not affect other decoding operations.
     */
    decode(data) {
        // Set the version of the decoding context of "data"
        const context = data.field('data');
        context.context.version = data.field('version').integer;
        return new VersionBox(context.decode(this.decoder));
    }
}
//# sourceMappingURL=VersionBox.js.map